import {Injectable, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from './auth.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SessionInactivityComponent} from '../../../shared/session-inactivity/session-inactivity.component';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {InactivityTime} from '../../../global/util/InactivityTime';
import {Session} from '../../../global/util/enum/Session';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {
  now = Date.now();
  interval: any;

  constructor(private router: Router,
              private ngZone: NgZone,
              private authenticate: AuthService,
              public modalService: NgbModal,
              private translate: TranslateService) {
    ('Start countDown Inactivity session');
    this.sessionDuration(Date.now());
    this.verifyInactivityTimer();
    this.initListener();
    this.initInterval();
  }

  /**
   * last action
   */
  getLastSessionDuration() {
    return LocalStorage.getLastSessionDuration();
  }

  /**
   * set last action
   */
  sessionDuration(value) {
    LocalStorage.setSessionDuration(value);
  }

  /**
   * start event listener
   */
  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
      document.body.addEventListener('keypress', () => this.reset());
      document.body.addEventListener('keyup', () => this.reset());
      document.body.addEventListener('scroll', () => this.reset());
    });
  }

  /*time interval*/
  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        this.verifyInactivityTimer();
      }, InactivityTime.MILLISECONDS);
    });
  }

  /* reset timer */
  reset() {
    this.sessionDuration(Date.now());
  }

  /**
   * Verify timer
   */
  verifyInactivityTimer() {
    if (this.isUserLoggedIn()) {
      this.now = Date.now();
      // tslint:disable-next-line:radix
      const differenceTime = parseInt(this.getLastSessionDuration()) + (InactivityTime.THIRTY_MINUTES) * InactivityTime.SECONDS * InactivityTime.MILLISECONDS;
      const isTimeout = (differenceTime - this.now) < 0;
      this.ngZone.run(() => {
        if (isTimeout) {
          clearInterval(this.interval);
          setTimeout(() => {
            this.showMessageCountDown(InactivityTime.MINUTES);
          }, 100);
        }
      });
    }
  }


  /*check if a user is logged in*/
  isUserLoggedIn(): boolean {
    return this.authenticate.isAuthenticated();
  }

  showMessageCountDown(minutes: number) {
    const openModal = this.modalService.open(SessionInactivityComponent, {
      backdrop: 'static',
    });
    openModal.componentInstance.minutes = minutes;
    openModal.result.then(result => {
      if (result === Session.KEEP) {
        console.log('KEEP SESSION');
        setTimeout(() => {
          this.sessionDuration(Date.now());
          this.verifyInactivityTimer();
        }, 500);
      } else {
        console.log('LOGOUT SESSION');
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-CLOSED-DUE-TO-INACTIVITY'), this.translate.instant('MESSAGE.LOGIN-AGAIN-TO-PLATFORM'));
        this.logout();
      }
      this.initInterval();
      this.initListener();
    });
  }

  /* Metodó que solo inactiva la sesión en el navegador, limpiando el localstorage.*/
  logout() {
    LocalStorage.removeSessionDuration();
    this.authenticate.logout();
    this.router.navigate(['login']);
  }
}
